"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyPopup = void 0;
var _react = require("react");
var _contexts = require("../../contexts");
var _Loading = require("../Loading");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const Content = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "BackInStockNotification_NotifyCumulus" */'../NotifyCumulus')))).NotifyCumulus
}));
const NotifyPopup = () => {
  const {
    close,
    loading,
    open
  } = (0, _contexts.useAppContext)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDialog, {
    open: open,
    onClose: close,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
      children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {})
    })
  });
};
exports.NotifyPopup = NotifyPopup;